import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { compareMonthsAll: { compareMonthsAll } } = apiUrls;

export const COMPARE_MONTHS_SALES_ALL_SUCCESS = 'COMPARE_MONTHS_SALES_ALL_SUCCESS';

export const COMPARE_MONTHS_ALL_LOADING = 'COMPARE_MONTHS_ALL_LOADING';


export const getCompareMonthAllData = ({ from, to, vendor }) => async (dispatch) => {
  try {
    if (vendor) {
      const requestData = { ...compareMonthsAll, url: compareMonthsAll.url.replace('{{vendor}}', vendor)
      .replace('{from}', from).replace('{to}', to) }       
      const data = await REQUEST(requestData);
      dispatch({
        type: COMPARE_MONTHS_SALES_ALL_SUCCESS,
        data,
        vendor
      })
    }

  } catch (e) {

    dispatch({
      type: COMPARE_MONTHS_SALES_ALL_SUCCESS,
      data: {
        code: "",
        modal: null,
        notifications: null,
        paginationInfo: null
      },
      vendor
    })
  }

}

export const handleAllLoader = (isAllLoading, vendor) => (dispatch) => {

  if (vendor) {
    dispatch({
      type: COMPARE_MONTHS_ALL_LOADING,
      isAllLoading,
      vendor
    })
  }
}